import FlashLib from "flashlib";
import * as PIXI from "pixi.js";
import {TweenMax} from "gsap";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";

export default class SymbolAnimation extends PIXI.Container {
    constructor(id, position, type = '') {
        super();

        this.offsets = {
            'symbol_1_min_spine': {x: 1, y: 0},
            'symbol_2_min_spine': {x: 1, y: 1},
            'symbol_3_min_spine': {x: 0, y: 1},
        };

        this.id = id;
        this.type = type !== '' ? '_' + type : type;
        this.symbolPosition = position;

        this.animation = null;

        //this.start();
    }

    start(animation) {
        /*this.animation = FlashLib.createItemFromLibrary('Symbol', 'GameFlashLib');
        this.animation.goToFrame(this.id);
        TweenMax.fromTo(this.animation, 1, {alpha: 1}, {alpha: 0, yoyo: true, repeat: 1});
        this.addChild(this.animation);
        GlobalDispatcher.dispatch('symbolAnimation:start', this.symbolPosition);*/

        let animationName = 'symbol_' + this.id + this.type + '_spine';

        let spineData = null;
        if (PIXI.Loader.shared.resources[animationName]) {
            spineData = PIXI.Loader.shared.resources[animationName].spineData;
        }
        if (spineData) {
            this._playSpineAnimation(spineData, animation);
        }

        if (this.animation) {
            let offset = this.offsets[animationName];
            if(offset) {
                this.animation.x += offset.x;
                this.animation.y += offset.y;
            }
            GlobalDispatcher.dispatch('symbolAnimation:start', this.symbolPosition);
        }
    }

    _playSpineAnimation(data, animation) {
        this.animation = new PIXI.spine.Spine(data);
        this.animation.state.setAnimation(0, animation, this.type !== '_min');
        this.animation.position.set(246 / 2, 246 / 2);
        //this.animation.position.set(this.animation.width / 2, this.animation.height / 2);
        this.animation.state.addListener({
            complete: () => {
                setTimeout(() => {
                    this._complete();
                }, 0);
            }
        });
        this.addChild(this.animation);
    }

    _complete() {
        if (this.animation) {
            GlobalDispatcher.dispatch('symbolAnimation:complete', this.symbolPosition);
            this.animation.destroy({children: true});
            this.animation = null;
        }
    }

    changeSkin(skinName) {
        this.animation.skeleton.setSkinByName(skinName);
    }

    stop() {
        if (this.animation) {
            GlobalDispatcher.dispatch('symbolAnimation:end', this.symbolPosition);
            this.animation.destroy({children: true});
            this.animation = null;
        }
    }
}
